// extracted by mini-css-extract-plugin
export var container = "_db-0";
export var content = "_db-3";
export var customerTitle = "_db-4";
export var empty = "_db-5";
export var gray = "_db-6";
export var header = "_db-7";
export var info = "_db-8";
export var loading = "_db-2";
export var loadingCard = "_db-9";
export var oneLine = "_db-a";
export var personName = "_db-e";
export var pillContainer = "_db-b";
export var selected = "_db-1";
export var text = "_db-c";
export var twoLines = "_db-d";
export var unread = "_db-f";
export var unreadIndicator = "_db-g";